import axios from "axios";
import jwt from "jwt-decode";
import { API_CONSTANTS } from "./Constants";

let API_BASE_ADDRESS

if(process.env.NODE_ENV === "development"){
    API_BASE_ADDRESS = "http://localhost:8080/"
}
else if (process.env.NODE_ENV === "production"){
  API_BASE_ADDRESS = process.env.REACT_APP_API_BASE_ADDRESS
}

const axiosInstance = axios.create({
  baseURL: API_BASE_ADDRESS,
  timeout: 20000,
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    console.log("axios interceptor - error", error);

    if(error.response === undefined) {
      return Promise.reject("Server Probably Down");
    }

    if (error.response.status === 401 && originalRequest.url === "refresh") {
      return Promise.reject(error);
    }

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.refreshToken;
      let decode = jwt(localStorage.token)
      const user = decode.user;

      return await axiosInstance
        .post(
          "refresh",
          {
            refreshToken: refreshToken,
            username: user.username,
          },
          { headers: {} }
        )
        .then((resp) => {
          if (resp.status === 200) {

            localStorage.clear();
            localStorage.setItem("token", resp.data.token);
            localStorage.setItem("refreshToken", resp.data.refreshToken);
          
            originalRequest.headers["Authorization"] =  "Bearer " + localStorage.token;
            axiosInstance.defaults.headers.common["Authorization"] =  "Bearer " + localStorage.token;
            return axiosInstance(originalRequest);
          }
        });
    }
    return Promise.reject(error);
  }
);

export async function doLogin(endpoint, payload) {

  return axios
      .post(API_BASE_ADDRESS + endpoint, payload)
      .then((resp) => {
        const decoded = jwt(resp.data.token);
        JSON.stringify(decoded.user);

        localStorage.setItem("token", resp.data.token);
        localStorage.setItem("refreshToken", resp.data.refreshToken);
        axiosInstance.defaults.headers.common["Authorization"] = "Bearer " + resp.data.token;

        return { message: "SUCCESS" };
      })
      .catch((e) => {
        return processException(e);
      });
}

export async function getRequest(endpoint) {
  return axiosInstance
    .get(endpoint)
    .then((resp) => {
      if (resp.status === 200) {
        return resp.data;
      }
    })
    .catch((e) => {

      return processException(e);

  });
}

export async function postRequest(endpoint, payload) {
  return axiosInstance
    .post(endpoint, payload)
    .then((resp) => {
      if (resp.status === 200) {
        return resp.data;
      }
    })
    .catch((e) => {
      return processException(e);
    });
}

export async function putRequest(endpoint, payload) {

  return axiosInstance
    .put(endpoint, payload)
    .then((resp) => {
      if (resp.status === 200) {
        return resp.data;
      }
    })
    .catch((e) => {
      return processException(e);
    });
}

export async function deleteRequest(endpoint) {

  return axiosInstance
    .delete(endpoint)
    .then((resp) => {
      if (resp.status === 200) {
        return resp.data;
      }
    })
    .catch((e) => {
      return processException(e);
    });
}

export async function reportDownloadRequest(endpoint) {

  return axiosInstance(endpoint, {
    method: "GET",
    responseType: "blob",
    timeout: 100000,
  })
    .then((response) => {
      return { message: "SUCCESS", data: response.data };
    })
    .catch((e) => {
      return processException(e);
    });
}

export async function reportDownloadAllRequest(list) {
  list.forEach(function (part, index) {
    this[index] = axiosInstance(part, {
      method: "GET",
      responseType: "blob",
      timeout: 100000,
    });
  }, list);

  return Promise
    .all(list)
    .then((responses) => {
        // console.log(responses);

        return { message: "SUCCESS", data: responses };

        // use/access the results
    })
    .catch((errors) => {
        
      //console.log(errors);
      return errors;
    });
}

export async function reportEmailAllRequest(list) {
  list.forEach(function (part, index) {
    this[index] = axiosInstance(part, {
      method: "GET",
      timeout: 100000,
    });
  }, list);

  return axiosInstance
    .all(list)
    .then(
      axiosInstance.spread((...responses) => {
        //console.log(responses);

        return { message: "SUCCESS", data: responses };

        // use/access the results
      })
    )
    .catch((errors) => {
      //console.log(errors);
      return errors;
    });
}

const processException = (e) => {

  console.log(e);

  // debugger

  if (e.response) {
    if (e.response.status === 400) {
      return e.response.data;
    } else if (e.response.status === 401) {
      return { message: API_CONSTANTS.UNAUTHORIZED };
    } else if (e.response.status === 500) {
      return { message: API_CONSTANTS.NO_CONNECTION };
    } else {
      return { message: API_CONSTANTS.TIMEOUT };
    }
  }

  if(e.code === undefined){
    return { message: API_CONSTANTS.SERVER_ERROR };
  }
}